/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/* prettier-ignore */


export const $SubscriptionCreateRequest = {
    properties: {
        accountId: {
            type: 'number',
            isRequired: true,
        },
        label: {
            type: 'string',
            isRequired: true,
        },
        serviceId: {
            type: 'number',
            isRequired: true,
        },
        invoiceCycleGroupId: {
            type: 'number',
            isNullable: true,
        },
        startDate: {
            type: 'Date',
            isRequired: true,
            format: 'date-time',
        },
        ratePlanId: {
            type: 'number',
            isNullable: true,
        },
        routePlanId: {
            type: 'number',
            isNullable: true,
        },
        defaultSubscriptionId: {
            type: 'number',
            isNullable: true,
        },
        hasServiceNumbers: {
            type: 'number',
        },
        defaultScenarioId: {
            type: 'number',
        },
        trackingGroupId: {
            type: 'number',
            isNullable: true,
        },
        translatedNumberStd: {
            type: 'string',
            isNullable: true,
        },
        defaultIsdnReleaseId: {
            type: 'number',
        },
        defaultIsdnReleaseMs: {
            type: 'number',
        },
        directSubscriptionId: {
            type: 'number',
            isNullable: true,
        },
        note: {
            type: 'string',
        },
        sourceSubscriptionId: {
            type: 'number',
            isNullable: true,
        },
        timezoneId: {
            type: 'number',
            isRequired: true,
            isNullable: true,
        },
        billDays: {
            type: 'number',
            isRequired: true,
        },
        dueDays: {
            type: 'number',
            isRequired: true,
        },
        disputeDays: {
            type: 'number',
            isRequired: true,
        },
        disputeResponseDays: {
            type: 'number',
            isRequired: true,
        },
        rateKeyDeleteDays: {
            type: 'number',
            isRequired: true,
        },
        rateKeyMatchIncreaseDays: {
            type: 'number',
            isRequired: true,
        },
        rateKeyExpandIncreaseDays: {
            type: 'number',
            isRequired: true,
        },
        duplicateSeconds: {
            type: 'number',
        },
        defaultMinimumSeconds: {
            type: 'number',
            isRequired: true,
        },
        defaultIncrementSeconds: {
            type: 'number',
            isRequired: true,
        },
        defaultIndeterminateRate: {
            type: 'number',
            isRequired: true,
        },
        defaultInterstateRate: {
            type: 'number',
            isRequired: true,
        },
        defaultIntrastateRate: {
            type: 'number',
            isRequired: true,
        },
        ratingParametersPriority: {
            type: 'Array',
        },
        externalAccountId: {
            type: 'string',
        },
        externalSubAccountId: {
            type: 'string',
        },
        defaultRoundingPrecision: {
            type: 'number',
        },
        attestation: {
            type: 'Attestation',
            isNullable: true,
        },
    },
};